import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthProvider';
import toast from 'react-hot-toast';

export function Login(): JSX.Element {
  const { t } = useTranslation();
  const { signInEmail, signInGoogle, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (user) {
    nav('/dashboard');
    return <></>;
  }

  const handleEmail = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await signInEmail(email, password);
      nav('/dashboard');
    } catch (err) {
      toast.error((err as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleGoogle = async (): Promise<void> => {
    setSubmitting(true);
    try {
      await signInGoogle();
      nav('/dashboard');
    } catch (err) {
      toast.error((err as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-primary/10 to-slate-50 p-6">
      <div className="card w-full max-w-md">
        <div className="text-3xl font-bold text-brand-primary mb-1">teleclaw</div>
        <p className="text-brand-muted mb-6">{t('login.title')}</p>
        <form onSubmit={handleEmail} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">{t('login.email')}</label>
            <input
              type="email" required
              className="input w-full"
              value={email} onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">{t('login.password')}</label>
            <input
              type="password" required
              className="input w-full"
              value={password} onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={submitting}>
            {t('login.signIn')}
          </button>
        </form>
        <div className="my-4 text-center text-sm text-brand-muted">—</div>
        <button type="button" onClick={() => void handleGoogle()} className="btn-secondary w-full" disabled={submitting}>
          {t('login.googleSignIn')}
        </button>
      </div>
    </div>
  );
}
